import Dialog, { IDialogProps } from '@/ui/dialog';
import { Button } from '@/ui/buttons';
import { useWallets, useProfile } from '@bitbot/model';
import { EyeOpen, EyeClose } from '@/ui/svg';
import SelfAvatar from '../User/SelfAvatar';
import Image from 'next/image';
import clsx from 'clsx';
import { MoreTwo } from '@/ui/svg';
import EditWalletDialog from './edit-wallet-dialog';
import { useState } from 'react';
import CreateNewWalletDialog from './create/create-new-wallet';
import {
  CreateWalletProvider,
  useGlobalValueStore,
  useCreateWallet,
} from '@bitbot/model';
import TotalUsdValue from '../common/total-usd-value';
import { sendGAEvent } from '@next/third-parties/google';

export default function ChangeWalletDialog(props: IDialogProps) {
  return (
    <CreateWalletProvider>
      <Content {...props} />
    </CreateWalletProvider>
  );
}

function Content(props: IDialogProps) {
  const { walletsByChain, currentWallet, setCurrentWallet } = useWallets();
  const { toggle } = props;
  const { setShowBalance, showBalance } = useGlobalValueStore();

  const [showEditDialog, setShowEditDialog] = useState(false);
  const { showCreateWalletDialog, setShowCreateWalletDialog } =
    useCreateWallet();

  const { userInfo } = useProfile();
  const [editWallet, setEditWallet] = useState<{
    name: string;
    address: string;
  }>();

  return (
    <>
      <Dialog {...props}>
        <div className="flex flex-col justify-between flex-grow font-nunito_sans pb-20 px-2">
          <div className="mb-6 flex flex-col gap-2 px-4">
            <div className="flex items-center justify-between">
              <div className="flex gap-3">
                <div className="w-6 h-6">
                  <SelfAvatar />
                </div>
                {userInfo?.nickname} -{' '}
                <span className="text-tertiary">All wallets</span>
              </div>
            </div>
            <TotalUsdValue isTotal={true} />
            <div
              onClick={() => {
                setShowBalance(!showBalance);
              }}
              className="text-tertiary flex items-center gap-2"
            >
              Est total value
              <div className="cursor-pointer flex flex-grow-0">
                {showBalance ? <EyeOpen /> : <EyeClose />}
              </div>
            </div>
          </div>
          {walletsByChain.map(({ chain, wallets }) => {
            return (
              <div key={chain}>
                <hr className="border-primary mx-4" />
                <div className="text-sm text-tertiary capitalize m-4">
                  {chain}
                </div>
                <div className="flex flex-col gap-4 ">
                  {wallets.map(({ name, balance, address }) => {
                    return (
                      <div
                        key={address}
                        onClick={() => {
                          setCurrentWallet(address);
                          setTimeout(() => {
                            toggle(false);
                          }, 200);
                        }}
                        className={clsx(
                          'flex justify-between py-3 p-4 cursor-pointer items-center relative',
                          currentWallet === address &&
                            'bg-tertiary rounded-lg',
                        )}
                      >
                        <div className="flex gap-3">
                          <Image
                            src={'/chain/base.png'}
                            width={40}
                            height={40}
                            alt="avatar/logo"
                            className="flex-shrink-0 w-10 h-10"
                          />
                          <div className="flex flex-col gap-1">
                            <div className="flex gap-1 items-center">
                              <div className="text-lg font-semibold leading-none">
                                {name}
                              </div>
                              <div className="text-xs bg-[#210784] px-[0.375rem] rounded-[0.25rem] flex items-center h-5 font-normal">
                                Keyless
                              </div>
                            </div>
                            <div className="text-tertiary felx justify-start">
                              {showBalance ? <>{balance} USD</> : '*****'}
                            </div>
                          </div>
                        </div>
                        <div
                          onClick={e => {
                            e.stopPropagation();
                            toggle(false);
                            setShowEditDialog(true);
                            setEditWallet({ name, address });
                          }}
                          className="cursor-pointer self-stretch flex items-center absolute top-0 bottom-0 right-0 w-8"
                        >
                          <MoreTwo />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
          <div className="px-6 fixed left-0 right-0  bottom-safe-area bottom-0 bg-modal pt-4">
            <Button
              className="text-xl"
              size="sm"
              onClick={() => {
                props.toggle(false);
                setShowCreateWalletDialog(true);
                sendGAEvent('event', 'click_add_wallet');
              }}
              type="primary"
            >
              Add wallet
            </Button>
          </div>
        </div>
      </Dialog>
      <EditWalletDialog
        open={showEditDialog}
        toggle={setShowEditDialog}
        currentWallet={editWallet}
        hideCloseIcon
      />
      <CreateNewWalletDialog
        open={showCreateWalletDialog}
        toggle={setShowCreateWalletDialog}
        hideCloseIcon
      />
    </>
  );
}
